import Spinner from "../../../components/Spinner/Spinner";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Buttons from "../../../components/Buttons/Buttons";
import PatientFormFields from "../Patient/PatientFormFields";
import PatientInfoView from "../Patient/PatientInfoView";

const ProfileTab = ({
  isEditingPatientInfo,
  setIsEditingPatientInfo,
  patientFormProps,
  isDeletingPatient,
  onDeletePatientClick,
}) => {
  return (
    <div className="tab-panel-content patientdetails">
      {patientFormProps.isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      {isEditingPatientInfo ? (
        <>
          <div className="tab-panel-header">
            <h3>Edit Patient Profile</h3>
          </div>
          <PatientFormFields
            formData={patientFormProps.formData}
            errors={patientFormProps.errors}
            gender={patientFormProps.gender}
            device={patientFormProps.device}
            data={patientFormProps.data}
            isEditing={patientFormProps.isEditing}
            resetPassword={patientFormProps.resetPassword}
            onChange={patientFormProps.handleChange}
            onCheckboxChange={patientFormProps.handleCheckboxChange}
            onRemoveDevice={patientFormProps.handleRemoveDevice}
            onDeviceSelect={patientFormProps.handleDeviceSelect}
            onResetPasswordClick={patientFormProps.onResetPasswordClick}
            showAcquisitionSettings={false}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "30px",
              borderTop: "1px solid #eee",
              paddingTop: "20px",
            }}
          >
            <Buttons
              text="Cancel"
              type="button"
              onClick={() => {
                patientFormProps.resetForm();
                setIsEditingPatientInfo(false);
              }}
              variant="secondary"
              style={{ width: "100px" }}
            />
            <Buttons
              text="Save"
              type="button"
              onClick={() =>
                patientFormProps.handleSubmit(
                  () => setIsEditingPatientInfo(false),
                  "basic",
                )
              }
              variant="primary"
              style={{ width: "100px" }}
            />
          </div>
        </>
      ) : (
        <>
          <div className="tab-panel-header">
            <h3>Patient Information</h3>
            <div style={{ display: "flex", gap: "10px" }}>
              <Buttons
                text="Edit"
                type="button"
                variant="primary"
                fullWidth={false}
                icon={<EditIcon fontSize="small" />}
                onClick={() => setIsEditingPatientInfo(true)}
              />
              <Buttons
                text={isDeletingPatient ? "Deleting..." : "Delete Patient"}
                type="button"
                variant="secondary"
                fullWidth={false}
                disabled={isDeletingPatient}
                icon={<DeleteOutlineIcon fontSize="small" />}
                onClick={onDeletePatientClick}
                style={{ color: "#d32f2f", borderColor: "#d32f2f" }}
              />
            </div>
          </div>
          <PatientInfoView
            formData={patientFormProps.formData}
            gender={patientFormProps.gender}
          />
        </>
      )}
    </div>
  );
};

export default ProfileTab;
